import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconWarningTriangle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.938 21.844'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.940,21.835 C22.933,21.835 22.927,21.835 22.920,21.835 L0.976,21.835 C0.624,21.835 0.297,21.649 0.118,21.346 C-0.062,21.044 -0.068,20.668 0.102,20.360 L11.074,0.460 C11.424,-0.175 12.472,-0.175 12.822,0.460 L23.709,20.206 C23.852,20.378 23.938,20.599 23.938,20.840 C23.938,21.389 23.491,21.835 22.940,21.835 ZM11.948,3.005 L2.663,19.845 L21.233,19.845 L11.948,3.005 ZM11.948,7.905 C12.499,7.905 12.946,8.350 12.946,8.900 L12.946,13.875 C12.946,14.424 12.499,14.870 11.948,14.870 C11.397,14.870 10.951,14.424 10.951,13.875 L10.951,8.900 C10.951,8.350 11.397,7.905 11.948,7.905 ZM12.659,16.153 C12.838,16.342 12.948,16.601 12.948,16.860 C12.948,17.119 12.838,17.377 12.649,17.566 C12.469,17.745 12.210,17.855 11.951,17.855 C11.681,17.855 11.432,17.745 11.243,17.566 C11.053,17.377 10.953,17.119 10.953,16.860 C10.953,16.601 11.053,16.342 11.243,16.153 C11.611,15.785 12.290,15.785 12.659,16.153 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconWarningTriangle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
